var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceFive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 157,
    viewBox: "0 0 145 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_220_3453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.189 52.2353C136.189 84.6901 109.731 111 77.0943 111C44.4574 111 18 84.6901 18 52.2353C18 19.7804 62.026 3 94.6629 3C127.3 3 136.189 19.7804 136.189 52.2353Z",
    fill: "#F9EEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5644 65.905C59.7641 65.905 59.9631 65.8287 60.1157 65.6768L73.43 52.3624C74.4688 52.737 75.5732 52.972 76.7211 53.0458V65.1261C76.7211 65.5565 77.0702 65.9056 77.5006 65.9056C77.931 65.9056 78.2801 65.5565 78.2801 65.1261V53.0452C79.428 52.9714 80.5325 52.7364 81.5712 52.3618L94.8856 65.6762C95.0375 65.8281 95.2372 65.9044 95.4369 65.9044C95.6365 65.9044 95.8356 65.8281 95.9882 65.6762C96.2926 65.3717 96.2926 64.8781 95.9882 64.5742L83.0992 51.6871C86.923 49.6686 89.5356 45.6519 89.5356 41.0356C89.5356 34.3989 84.1367 29 77.5 29C70.8633 29 65.4637 34.3995 65.4637 41.0356C65.4637 45.6519 68.0764 49.6686 71.9002 51.6871L59.0131 64.5742C58.7086 64.8787 58.7086 65.3717 59.0131 65.6762C59.1656 65.8287 59.3647 65.905 59.5644 65.905ZM77.5 51.5129C74.9475 51.5129 72.6059 50.595 70.7864 49.0726C71.5653 46.0327 74.3199 43.869 77.5 43.869C80.6801 43.869 83.4347 46.0327 84.2136 49.0726C82.3941 50.595 80.0525 51.5129 77.5 51.5129ZM67.0228 41.0356C67.0228 35.2584 71.7228 30.5584 77.5 30.5584C83.2772 30.5584 87.9772 35.2584 87.9772 41.0356C87.9772 43.6309 87.0284 46.0085 85.4595 47.8404C84.244 44.5661 81.0937 42.31 77.5 42.31C73.9063 42.31 70.7554 44.5661 69.5399 47.8404C67.9716 46.0085 67.0228 43.6309 67.0228 41.0356ZM77.5 41.8145C79.895 41.8145 81.8441 39.866 81.8441 37.4705C81.8441 35.0755 79.8956 33.127 77.5 33.127C75.1044 33.127 73.1559 35.0755 73.1559 37.4705C73.1566 39.866 75.105 41.8145 77.5 41.8145ZM77.5 34.686C79.0355 34.686 80.285 35.935 80.285 37.4705C80.285 39.0059 79.0355 40.2555 77.5 40.2555C75.9645 40.2555 74.715 39.0059 74.715 37.4705C74.715 35.9356 75.9645 34.686 77.5 34.686ZM64.9825 68.238H53.8715C53.665 68.238 53.4666 68.3198 53.3202 68.4662L50.2282 71.5582C50.0819 71.7045 50 71.9024 50 72.1095V83.2205C50 83.6509 50.3491 84 50.7795 84H61.8905C62.097 84 62.2955 83.9181 62.4418 83.7718L65.5338 80.6798C65.6802 80.5334 65.762 80.3356 65.762 80.1285V69.0169C65.7614 68.5865 65.4129 68.238 64.9825 68.238ZM61.568 71.3293H59.8236L61.3566 69.7964H63.101L61.568 71.3293ZM55.5074 72.8884H57.162V75.0347H55.5074V72.8884ZM56.61 71.3293L58.143 69.7964H59.152L57.619 71.3293H56.61ZM54.194 69.7964H55.9384L54.4055 71.3293H52.661L54.194 69.7964ZM51.559 72.8884H53.949V75.8142C53.949 76.2446 54.2982 76.5937 54.7285 76.5937H57.9421C58.3725 76.5937 58.7216 76.2446 58.7216 75.8142V72.8884H61.1116V82.441H51.559V72.8884ZM62.67 81.3384V72.4313L64.203 70.8984V79.8054L62.67 81.3384ZM84.6012 68.238H73.4902C73.2837 68.238 73.0852 68.3198 72.9389 68.4662L69.8469 71.5582C69.7005 71.7045 69.6187 71.9024 69.6187 72.1095V83.2205C69.6187 83.6509 69.9678 84 70.3982 84H81.5092C81.7157 84 81.9141 83.9181 82.0605 83.7718L85.1525 80.6798C85.2988 80.5334 85.3807 80.3356 85.3807 80.1285V69.0169C85.3807 68.5865 85.0316 68.238 84.6012 68.238ZM81.1867 71.3293H79.4423L80.9752 69.7964H82.7197L81.1867 71.3293ZM75.1267 72.8884H76.7813V75.0347H75.1267V72.8884ZM76.2287 71.3293L77.7617 69.7964H78.7707L77.2377 71.3293H76.2287ZM73.8133 69.7964H75.5577L74.0247 71.3293H72.2803L73.8133 69.7964ZM71.1777 72.8884H73.5677V75.8142C73.5677 76.2446 73.9168 76.5937 74.3472 76.5937H77.5608C77.9911 76.5937 78.3403 76.2446 78.3403 75.8142V72.8884H80.7303V82.441H71.1777V72.8884ZM82.2887 81.3384V72.4313L83.8217 70.8984V79.8054L82.2887 81.3384ZM104.22 68.238H93.1095C92.903 68.238 92.7045 68.3198 92.5582 68.4662L89.4662 71.5582C89.3198 71.7045 89.238 71.9024 89.238 72.1095V83.2205C89.238 83.6509 89.5871 84 90.0175 84H101.128C101.335 84 101.533 83.9181 101.68 83.7718L104.772 80.6798C104.918 80.5334 105 80.3356 105 80.1285V69.0169C105 68.5865 104.651 68.238 104.22 68.238ZM100.806 71.3293H99.0616L100.595 69.7964H102.339L100.806 71.3293ZM94.746 72.8884H96.4005V75.0347H94.746V72.8884ZM95.848 71.3293L97.381 69.7964H98.3899L96.857 71.3293H95.848ZM93.432 69.7964H95.1764L93.6434 71.3293H91.899L93.432 69.7964ZM90.797 72.8884H93.187V75.8142C93.187 76.2446 93.5361 76.5937 93.9665 76.5937H97.1801C97.6104 76.5937 97.9596 76.2446 97.9596 75.8142V72.8884H100.35V82.441H90.797V72.8884ZM101.908 81.3384V72.4313L103.441 70.8984V79.8054L101.908 81.3384Z",
    fill: "#FF3833"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_220_3453",
    x: 0,
    y: 0,
    width: 144.188,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_3453"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_220_3453",
    result: "effect2_dropShadow_220_3453"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_220_3453",
    result: "effect3_dropShadow_220_3453"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_220_3453",
    result: "effect4_dropShadow_220_3453"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_220_3453",
    result: "effect5_dropShadow_220_3453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_220_3453",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFive);
export default __webpack_public_path__ + "static/media/serviceFive.75daf016f4024e509eb7b89afccf9034.svg";
export { ForwardRef as ReactComponent };